import React from "react";
import s from '../../../styles/components/onboarding/keyboard-setup/keyboard-setup-complete-page.module.scss';
import {onboardingImagesSource} from "../../../config/config";
import Button from "../../common/Button";
import settingsService from "../../../services/settings/settingsService";
import BackButton from "../../common/BackButton";
import {DynamicImage} from "../../common/DynamicImage";
import {keyboardWizardStore} from "../../../redux/keyboardWizard/keyboardWizardStore";
import {KeyboardWizardPage} from "../../../redux/keyboardWizard/keyboardWizardTypes";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/keyboard-wizard';

interface IKeyboardSetupCompleteProps {
  onStartPlaying: () => void,
  isBackButtonShown: boolean,
  mode: "fullscreen" | "modal"
}

export default function KeyboardSetupComplete({onStartPlaying, isBackButtonShown, mode}: IKeyboardSetupCompleteProps) {
  const setKeySizeLabel = function(keyCount: number | string) {
    if (keyCount === 'Custom') {
      return `Custom size set`
    }

    return `Size set to ${keyCount} keys`;
  }

  const keySizeLabel: string = setKeySizeLabel(settingsService.getKeyboardKeysSettings().numberOfKeys);
  const fullscreenClassName = mode === "fullscreen" ? s.fullscreen : "";

  return (
    <div className={`${s.container} ${fullscreenClassName}`}>
      <div className={s.back}>
        {isBackButtonShown ? <BackButton useClassName={s.backButton} onClick={() => { keyboardWizardStore.setCurrentPage(KeyboardWizardPage.SetHighestNote); }} analyticsIdentifier={'keyboard-wizard-complete-back'} analyticsScreenClass={screenClass}/> : null}
      </div>
      <header>Setup complete!</header>
      <div className={s.keyboard}>
        <DynamicImage additionalClassName={s.keyboardImage}
          pngSrc={onboardingImagesSource.keyboardWithoutHighlights}
          webpSrc={onboardingImagesSource.keyboardWithoutHighlightsWEBP} />
      </div>
      <ul className={s.summaryChecklist}>
        <li><span className={s.summaryChecklistLabel}>Instant feedback enabled</span></li>
        <li><span className={s.summaryChecklistLabel}>{keySizeLabel}</span></li>
      </ul>
      <footer>
        <Button
          additionalClassName={s.startPlayingButton}
          text="Start&nbsp;Playing"
          onClick={() => {
            inAppAnalyticsService.onButton_press('keyboard-wizard-complete-start-playing', {screenClass});
            keyboardWizardStore.setIsOpen(false);
            onStartPlaying();
          }}
          buttonType={"secondary"}
          navigationNote={"D"} />
      </footer>
    </div>
  );
}
